import { render } from "./BcacsView.vue?vue&type=template&id=8126d9f0"
import script from "./BcacsView.vue?vue&type=script&lang=js"
export * from "./BcacsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__